var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.showImagePopup
      ? _c(
          "div",
          { staticClass: "image-popup", on: { click: _vm.closePopupImage } },
          [
            _c(
              "div",
              {
                staticClass: "popup-content",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "action-btn close-btn",
                    on: { click: _vm.closePopupImage }
                  },
                  [_vm._v("ปิด")]
                ),
                _vm._v(" "),
                _vm.imageScale !== 1
                  ? _c(
                      "button",
                      {
                        staticClass: "action-btn reset-btn",
                        on: { click: _vm.resetImage }
                      },
                      [_vm._v("รีเซ็ต")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "image-container",
                    on: {
                      wheel: _vm.handleWheel,
                      touchstart: _vm.handleTouchStart,
                      touchmove: _vm.handleTouchMove,
                      touchend: _vm.handleTouchEnd
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "popup-image",
                      style: {
                        transform:
                          "scale(" +
                          _vm.imageScale +
                          ") translate(" +
                          _vm.imagePosition.x +
                          "px, " +
                          _vm.imagePosition.y +
                          "px)",
                        cursor: _vm.imageScale > 1 ? "move" : "zoom-in"
                      },
                      attrs: { src: _vm.popupImageUrl, alt: "Popup image" }
                    })
                  ]
                )
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          !_vm.warningText && _vm.examinationDetail
            ? [
                _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-lg",
                        attrs: { id: "state_question" }
                      },
                      [
                        _vm._v(
                          "ข้อ " +
                            _vm._s(parseFloat(_vm.countHasDone) + 1) +
                            " /\n              " +
                            _vm._s(_vm.countAll) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.examinationDetail.question && _vm.fadeShow
                    ? _c("div", { staticClass: "row mt-5" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c("h3", {
                            staticStyle: { "line-height": "1.8" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.convertLineBreaks(
                                  _vm.examinationDetail.question.name
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.examinationDetail.question.image_url
                            ? _c("div", [
                                _c("img", {
                                  staticClass:
                                    "img-fluid mb-3 w-100 clickable-image",
                                  staticStyle: {
                                    "object-fit": "cover",
                                    border: "2px solid #dee2e6",
                                    cursor: "pointer"
                                  },
                                  attrs: {
                                    src:
                                      _vm.examinationDetail.question.image_url,
                                    alt: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showPopupImage(
                                        _vm.examinationDetail.question.image_url
                                      )
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.examinationDetail.question &&
                _vm.examinationDetail.question.question_answers
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.checkAnswer.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("transition", { attrs: { name: "fade" } }, [
                          _vm.fadeShow
                            ? _c("div", { staticClass: "row mb-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c("hr", {
                                      staticStyle: { margin: "10px 0 20px 0" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.examinationDetail.question
                                        .question_answers,
                                      function(item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: item.id + "-" + index,
                                            staticClass: "card"
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "card-body mb-0",
                                                class: {
                                                  "active-box":
                                                    _vm.formData
                                                      .question_answer_id ===
                                                    item.id
                                                },
                                                staticStyle: {
                                                  "padding-left": "2rem"
                                                },
                                                attrs: {
                                                  for: "exam-" + item.id
                                                }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.formData
                                                          .question_answer_id,
                                                      expression:
                                                        "formData.question_answer_id"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: {
                                                    type: "radio",
                                                    name: "exampleRadios",
                                                    id: "exam-" + item.id
                                                  },
                                                  domProps: {
                                                    value: item.id,
                                                    checked: _vm._q(
                                                      _vm.formData
                                                        .question_answer_id,
                                                      item.id
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.$set(
                                                        _vm.formData,
                                                        "question_answer_id",
                                                        item.id
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-check-label"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.getThaiIndex(
                                                            index
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("span", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.convertLineBreaks(
                                                            item.name
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.image_url
                                                  ? _c("div", [
                                                      _c("img", {
                                                        staticClass:
                                                          "img-fluid mt-2 w-100 clickable-image",
                                                        staticStyle: {
                                                          "object-fit": "cover",
                                                          cursor: "pointer"
                                                        },
                                                        attrs: {
                                                          src: item.image_url,
                                                          alt: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.showPopupImage(
                                                              item.image_url
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "mt-3 btn btn-block btn-lg btn-info",
                                        attrs: {
                                          disabled:
                                            _vm.submitting ||
                                            !_vm.formData.question_answer_id,
                                          type: "submit"
                                        }
                                      },
                                      [_vm._v("ส่งคำตอบ\n                ")]
                                    )
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : [
                _c(
                  "div",
                  { staticClass: "text-center mt-5" },
                  [
                    _vm.warningCode == 200
                      ? [
                          _c("i", {
                            staticClass:
                              "fas fa-3x fa-exclamation-circle text-warning"
                          })
                        ]
                      : _vm.warningCode == 204
                      ? [
                          _c("i", {
                            staticClass:
                              "fas fa-3x fa-check-circle text-success"
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h2", { staticClass: "mt-3" }, [
                      _vm._v(_vm._s(_vm.warningText))
                    ]),
                    _vm._v(" "),
                    _vm.score
                      ? [
                          _c("h2", [
                            _vm._v("คุณได้คะแนนรวม "),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(_vm.score) +
                                " / " +
                                _vm._s(_vm.countAll) +
                                " คะแนน"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "mt-3 btn btn-block btn-lg btn-success",
                              attrs: {
                                to: {
                                  name: "Admin Tests",
                                  params: { id: _vm.adminId },
                                  query: { validationCode: _vm.validationCode }
                                }
                              }
                            },
                            [_vm._v("กลับไปยังหน้ารายการ\n            ")]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-523b5af6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523b5af6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/AdminTest.vue
// module id = 2292
// module chunks = 0